import { useRef } from 'react';
import { cn } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import Section from '@Components/Section';
import useMedias from '@Hooks/useMedias';
import ProductsGallery from './elements/ProductsGallery';
import VerticalProductsList from './elements/VerticalProductsList';
import ImageWithPins from './elements/ImageWithPins/ImageWithPins';
import styles from './ProductsInInterior.module.css';

import type { FC } from 'react';
import type { ProductData } from '@Types/Product';
import type { SectionProps } from '@Components/Section';
import type { FindYourOwnImage } from '@Pages/PageProduct/typings';

export interface ProductsInInteriorProps extends SectionProps {
  title: string;
  img?: FindYourOwnImage;
  products?: ProductData[];
  analyticsTitle?: string;
}

const ProductsInInterior: FC<ProductsInInteriorProps> = (props) => {
  const { className, img, products, analyticsTitle, ...restProps } = props;
  const { isDesktop } = useMedias();
  const { t } = useTranslation();
  const refGrid = useRef<HTMLDivElement>(null);
  const listTitle = `${analyticsTitle} ФРК карточка товара`;
  const analyticsData = { label: 'Листинг', listTitle, orderType: 'Листинг' };

  return (
    <>
      <Section
        {...restProps}
        title={t('find-yours.title')}
        className={cn(styles.container, className)}
      >
        <div className={styles.wrapper}>
          <div className={styles.imgContainer} ref={refGrid}>
            <ImageWithPins img={img} refGrid={refGrid} analyticsData={analyticsData} />
          </div>
          {!isDesktop && <VerticalProductsList products={products} analyticsTitle={listTitle} />}
        </div>
      </Section>
      {isDesktop && (
        <ProductsGallery
          className={styles.gallery}
          analyticsTitle={listTitle}
          products={products}
        />
      )}
    </>
  );
};

export default ProductsInInterior;
